import React, { useRef, useState } from 'react';
import './AssignDemoTrialLicense.css';
import PopupDialog from 'src/SharedComponents/PopupDialog/PopupDialog';
import close from 'src/images/close.png';
import SearchBar from 'src/SharedComponents/SearchBar/SearchBar';
import TableHead from "src/SharedComponents/Table/TableHead";
import { useSearch } from "src/Utils/Hooks/SearchData/useSearch";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import Button from 'src/SharedComponents/Button/Button';
import useSortableData, { SortConfig } from 'src/Utils/Hooks/SortableData/useSortableData';
import { useAuraSupportInfo } from 'src/Utils/Hooks/UseAuraInfoContext';
import { IPartner } from 'src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo';
import { formatDateString } from 'src/Utils/DateFormatting/DateFormatter';

interface AssignDemoTrialLicenseProps {
    licenseType: string;
    onClose: () => void;
    onSubmit: (clinicId: string, licenseType: string, clinicName: string) => void;
}


const AssignDemoTrialLicenseToPartner: React.FC<AssignDemoTrialLicenseProps> = ({licenseType, onClose, onSubmit}) => {
    const [searchText, setSearchText] = useState<string>('');
    const { adminDetails } = useAuraSupportInfo();

    let conf: SortConfig<IPartner> = {
        key: 'name',
        direction: 'ascending'
    };

    const searchKeys = useRef<(keyof IPartner)[]>(['name'])
    const partnerSearch = useSearch(adminDetails?.partners, searchText, searchKeys.current);
    const { items, requestSort, sortConfig } = useSortableData(partnerSearch, conf);

    return (
        <div className="assignLicenseToPartner">
            <PopupDialog onClose={() => onClose()} marginTop="120px" popupWidth="45%">
                <div className="assign-license-header d-flex flex-column row">
                    <div className="row">
                        <div className="col-md-10">
                            <span style={{ fontWeight: '600', fontSize: '24px' }}>Assign Demo/Trail License</span>
                        </div>
                        <div className="col-md-2">
                            <i style={{ color: '#A8927D', cursor: 'pointer' }} onClick={() => { onClose() }}>
                                <img src={close} className='close-icon' alt="close" />
                            </i>
                        </div>
                    </div>
                    <div className="row ps-4" style={{ fontSize: '16px', color: '#A8927D', fontWeight: '400' }}>
                        Select a Partner
                    </div>
                    <div className="row mt-4">
                        <SearchBar onChange={(text:string) => {setSearchText(text) }} />
                    </div>
                </div>
                <div className="table-responsive" style={{overflowX:"hidden", borderRadius:'20px', marginBottom:'2px'}}>
                <table data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <TableHead<IPartner>
                                    columnName="Partner" 
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="name"
                                />
                               
                                <TableHead<IPartner>
                                    columnName="Country"
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="country"
                                />

                                <TableHead<IPartner>
                                    columnName="SetUpDate" 
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="setUpDate"
                                />
                                <th className={tableStyles.heading}>{ }</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((partner, i) => (
                                <tr key={i}>
                                    <td className={tableStyles.data} style={{width:"40%", paddingLeft:'25px' }}>
                                        {partner.name}
                                    </td>
                                    <td className={tableStyles.data} style={{width:"30%", paddingLeft:'25px' }}>
                                        {partner.country}
                                    </td>
                                    <td className={tableStyles.data} style={{width:"30%", paddingLeft:'25px'  }}>
                                        {formatDateString(partner.setUpDate)}
                                    </td>
                                    <td className={tableStyles.data} style={{ fontWeight: 600}}>
                                        <Button
                                            backgroundColor="#A8927D"
                                            color="white"
                                            text="Assign"
                                            borderColor="none"
                                            fontSize="12px"
                                            width='127px'
                                            onClick={()=>onSubmit(partner.distributorId, licenseType, partner.name)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        
                        </tbody>
                    </table>
                </div>
            </PopupDialog>
        </div>
    );
};

export default AssignDemoTrialLicenseToPartner;